import L from 'leaflet';

export const CustomDrawGroupPicker = L.Control.extend({
  options: {
    position: 'topleft',
  },
  onAdd() {
    const container = L.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-custom draw-group-control');

    const anchor = L.DomUtil.create('a');
    anchor.title = 'Draw Group Action';
    anchor.setAttribute('style', 'background-color: var(--secondary-color);');

    const button = L.DomUtil.create('button', 'button-draw-group-control');
    button.type = 'button';
    button.innerText = 'LG';
    button.setAttribute('style', 'background-color: transparent;color: white;border: none;cursor: pointer;');
    button.id = 'customDrawGroupPicker';

    anchor.appendChild(button);
    container.appendChild(anchor);

    return container;
  },
});
